'use client';
import styled from 'styled-components';

export const StyledQuizCallout = styled.div`
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  border-radius: 10px;
  padding: ${props => props.theme.spacing(4)};
  max-width: 345px;
  display: ${props => (props.$hideCallout ? 'none' : 'flex')};
  gap: ${props => props.theme.spacing(4)};
  text-align: left;
  align-items: center;
  margin-top: ${props => props.theme.spacing(3)};
  @media ${props => props.theme.tabletL} {
    display: flex;
    margin: ${props => props.theme.spacing(...props.$margin)};
  }
`;

export const Content = styled.div``;

export const Headline = styled.p`
  ${props => props.theme.typography.bodyBold};
`;

export const Subheadline = styled.p`
  ${props => props.theme.typography.body};
`;

export const Attribute = styled.p`
  ${props => props.theme.typography.label};
  color: ${props => props.theme.colors.text.primary};
`;
